<div class="modal-header confirm">
    <h2 class="modal-title">Refund Transaction</h2>
    <button (click)="dismiss()" aria-label="Close" class="reset-width close" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

@if (view === 'form') {
    <div class="modal-body">
        <p class="mb-3">
            Refund <strong>{{ account?.customer }}</strong>@if (account?.accountNumber) {
            <span> ({{ account?.accountNumber }})</span>
        }. Amount paid: <strong>{{ maxAmountCents | toMajor | currency:'R ' }}</strong>. </p>

        <form [formGroup]="form">
            <div class="form-group mb-3">
                <validation [formGroup]="form" controlName="amount" displayName="Refund amount">
                    <label for="refundAmount">Refund Amount (R)</label> <input class="form-control"
                                                                               formControlName="amount"
                                                                               id="refundAmount"
                                                                               step="0.01"
                                                                               type="number"/>
                    <small class="text-muted"> Between {{ minAmountCents | toMajor | currency:'R ' }}
                        and {{ maxAmountCents | toMajor | currency:'R ' }}. </small>
                </validation>
            </div>

            <div class="form-group mb-2">
                <label for="refundDescription">Description (Optional)</label> <input [maxlength]="maxDescriptionLength"
                                                                                     class="form-control"
                                                                                     formControlName="description"
                                                                                     id="refundDescription"
                                                                                     placeholder="Shown to the customer on the refund page"
                                                                                     type="text"/>
            </div>
        </form>

        @if (errorMessage) {
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
        }
    </div>
    <div class="modal-footer">
        <button (click)="dismiss()" [disabled]="submitting" class="btn btn-light" type="button">Cancel</button>
        <button (click)="submit()" [disabled]="form.invalid || submitting" class="btn btn-dark" type="button">
            @if (submitting) {
                Processing…
            } @else {
                Refund {{ amountCents | toMajor | currency:'R ' }}
            }
        </button>
    </div>
}

@if (view === 'result') {
    <div class="modal-body">
        @if (resultFailed) {
            <div class="alert alert-danger" role="alert">
                <strong>Refund failed.</strong>
                @if (result?.failureMessage) {
                    <div>{{ result?.failureMessage }}</div>
                }
            </div>
        } @else {
            <p>
                <strong>Refund link created.</strong> Share this refund link with the customer to complete the refund:
            </p><label for="refundUrl">Refund Link</label>
            <div class="input-group mb-2">
                <input [value]="result?.refundUrl ?? ''"
                       class="form-control refund-link-input"
                       id="refundUrl"
                       readonly
                       type="text"/>
                <button (click)="openLink()" class="btn btn-light" type="button">Open</button>
            </div>
            @if (result?.expiresAt) {
                <small class="text-muted"> Link expires {{ result?.expiresAt | amFromUtc | amTimeAgo }}
                    ({{ result?.expiresAt | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm' }}). </small>
            }
            @if (result?.refundUrl) {
                <hr class="my-3"/><p class="mb-2">Or send the refund link to the customer directly:</p>
                <form [formGroup]="sendForm">
                    <div class="form-group mb-2">
                        <label for="refundSendEmail">Email</label>
                        <div class="input-group">
                            <input class="form-control"
                                   formControlName="email"
                                   id="refundSendEmail"
                                   placeholder="customer@example.com"
                                   type="email"/>
                            <button (click)="sendEmail()"
                                    [disabled]="sendingEmail || sendingSms || sendForm.controls.email.invalid || !sendForm.controls.email.value"
                                    class="btn btn-dark"
                                    type="button">
                                @if (sendingEmail) {
                                    Sending…
                                } @else if (emailAlreadySent) {
                                    Sent
                                } @else {
                                    Send Email
                                }
                            </button>
                        </div>
                        <validation [formGroup]="sendForm" controlName="email" displayName="Email"></validation>
                    </div>
                    <div class="form-group mb-1">
                        <label for="refundSendMobile">Mobile Number</label>
                        <div class="input-group">
                            <input class="form-control"
                                   formControlName="mobileNumber"
                                   id="refundSendMobile"
                                   placeholder="0XX XXX XXXX"
                                   type="tel"/>
                            <button (click)="sendSms()"
                                    [disabled]="sendingEmail || sendingSms || sendForm.controls.mobileNumber.invalid || !sendForm.controls.mobileNumber.value"
                                    class="btn btn-dark"
                                    type="button">
                                @if (sendingSms) {
                                    Sending…
                                } @else if (smsAlreadySent) {
                                    Sent
                                } @else {
                                    Send SMS
                                }
                            </button>
                        </div>
                        <validation [formGroup]="sendForm"
                                    controlName="mobileNumber"
                                    displayName="Mobile number"></validation>
                    </div>
                </form>
                @if (sendError) {
                    <div class="alert alert-danger mt-2" role="alert">{{ sendError }}</div>
                }
            }
            @if (errorMessage) {
                <div class="alert alert-danger mt-2" role="alert">{{ errorMessage }}</div>
            }
        }
    </div>
    <div class="modal-footer">
        @if (!resultFailed) {
            <button (click)="cancelRefund()"
                    [disabled]="cancelling || sendingEmail || sendingSms"
                    class="btn btn-light"
                    type="button">
                @if (cancelling) {
                    Cancelling…
                } @else {
                    Cancel Refund
                }
            </button>
        }
        <button (click)="done()"
                [disabled]="cancelling || sendingEmail || sendingSms"
                class="btn btn-dark"
                type="button">Done
        </button>
    </div>
}
